
import React from "react";
import { FileText, Download } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

interface ExportDropdownProps {
  onExport: (type: string) => void;
}

const ExportDropdown = ({ onExport }: ExportDropdownProps) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          className="border-primary/20 hover:bg-primary/10 flex items-center gap-2"
        >
          <FileText size={16} />
          Project Export
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="bg-black/80 border-primary/20 text-white">
        <DropdownMenuLabel>Izvezi podatke</DropdownMenuLabel>
        <DropdownMenuSeparator className="bg-primary/20" />
        <DropdownMenuItem 
          onClick={() => onExport("JSON")}
          className="hover:bg-primary/30 cursor-pointer"
        >
          Izvoz u JSON
        </DropdownMenuItem>
        <DropdownMenuItem 
          onClick={() => onExport("CSV")}
          className="hover:bg-primary/30 cursor-pointer"
        >
          Izvoz u CSV
        </DropdownMenuItem>
        <DropdownMenuItem 
          onClick={() => onExport("PDF")}
          className="hover:bg-primary/30 cursor-pointer"
        >
          Izvoz u PDF
        </DropdownMenuItem>
        <DropdownMenuSeparator className="bg-primary/20" />
        <DropdownMenuItem 
          onClick={() => onExport("INSTALL")}
          className="hover:bg-primary/30 cursor-pointer flex items-center gap-2"
        >
          <Download size={16} />
          Kompletna instalacijska dokumentacija
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default ExportDropdown;
